export const API_ENDPOINTS = {
  NEXT_QUESTION: '/game/next-question',
  REGISTER_PLAYER: '/user/register-player',
  ACTIVE_PLAYERS: '/admin/game/active-players',
  SUBMIT_QUESTION: '/game/submit-question',
  GET_LEADER_BOARD: '/game/get-leader-board',
  AI_GENERATE_QUIZ: '/admin/game/ai-generate-quiz',
  AI_CREATE_QUESTION_GAME: '/admin/game/create-quiz-game',
  GEO_NEXT_PLAY: '/game/fetch-next-geoplay',
  GEO_LEADER_BOARD: '/game/get-geo-leader-board',
  GEO_PLAYER_SESSION: '/game/fetch-geoplay-session-stat',
  GEO_CREATE_GAME: '/admin/game/create-geoplay-games',
  SUBMIT_GEO_PLAY: '/game/submit-geoplay',
  PREVIEW_LEADERBOARD: '/admin/game/fetch-preview-leaderboard',
  PREVIEW_PLAYERS: '/fetch-preview-players',
  SUBSCRIBER_GAME_LIST: '/admin/game/fetch-subscriber-game-list',
  GOOGLE_SIGN_URL: '/user/google-login',
  CUSTOM_LOGIN: '/user/login',
  USER_SIGNUP: '/user/create-subscriber',
  VERIFY_EMAIL: '/user/verify-subscriber',
  FORGOT_PASSWORD: '/user/forgot-password',
  RESET_PASSWORD: '/user/reset-password',
  CREATE_SUBSCRIPTION: '/onboarding/assign-subscription-plan',
  GAME_DETAILS: '/admin/game/fetch-game-details',
  BUSINSESS_CATEGORIES: '/onboarding/fetch-business-categories',
  FETCH_PLAYER_SUMMARY: '/admin/game/fetch-player-summary',
  FETCH_INVITEES: '/admin/manage/get-invited-players',
  SEND_INVITE_TO_PLAYERS: '/admin/manage/send-invite',
  TOKEN_REFRESH: '/user/auth/token/refresh',
  COUNTRY_API: '/mbaonye',
  FETCH_QUIZ_PREVIEW: '/admin/game/fetch-quiz-preview',
  FETCH_GAME_DETAIL_STATISTICS: '/admin/game/fetch-game-stats',
  HOST_START_GAME: '/admin/game/start-game',
  FETCH_LEADERBOARD: '/realtime/leaderboard',
  FETCH_GAME_STATUS: '/realtime/game-status',
  HOST_FETCH_QUESTION: '/realtime/secure/quiz',
  GET_QR_CODE: '/admin/game/get-qr-code',
  SKETCHER_SUBMIT: '/game/submit-sketcher',
  NEXT_GEO_PLAY_ROUND: '/realtime/secure/geo',
  CURRENT_GEO_ROUND_RESULT: '/realtime/secure/geo/result',
  GEO_TOP_3_PLAYERS_SUMMARY: '/realtime/final-top-players/summary',
  CREATE_SKETCHER_GAME: '/admin/game/create-sketcher-game',
};
